/** Ключ RuleFlags запрета атак. Значение: `'A' | 'B' | 'all'` (иначе — разрешено). */
export const ATTACK_PROHIBITION_RULE = 'attackProhibition';
/**
 * Читает запрет атак для конкретной стороны из RuleFlags. Единственная точка
 * интерпретации флага (вызывается из `attackEligibility`).
 */
export function attackProhibitedForSide(rules, side) {
    const value = rules[ATTACK_PROHIBITION_RULE];
    return value === 'all' || value === side;
}
//# sourceMappingURL=rules.js.map